/**
 * @fileoverview
 * Space System for game logic
 */
'use strict';

goog.provide("Ntry.Animator");

goog.require("Ntry.STATIC");

Ntry.Animator = function() {

};

(function(p) {
    p.update = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.ANIMATE);

        for (var id in entities) {
            var entity = entities[id];
            this._applyAnimation(entity);
        }
    };

    p._applyAnimation = function(entity) {
        var animate = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.ANIMATE
        );
        var bitmapComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.BITMAP
        );
        var spriteComp = Ntry.entityManager.getComponent(
            entity.id, Ntry.STATIC.SPRITE
        );
        var displayComp = bitmapComp || spriteComp;
        if (!displayComp)
            return;

        switch(animate.animateType) {
            case Ntry.STATIC.ROTATE:
                break;
            case Ntry.STATIC.ROTATE_TO:
                displayComp.rotation =
                    (displayComp.rotation * 3 + animate.animateValue) / 4;
                if (animate.currentFrame >= 10) {
                    displayComp.rotation = animate.animateValue;
                    Ntry.entityManager.removeComponent(
                        entity.id, Ntry.STATIC.ANIMATE);
                }
                break;
            case Ntry.STATIC.ROTATE_INFINITE:
                displayComp.rotation += animate.animateValue;
                break;
            case Ntry.STATIC.FADE_OUT:
                if (displayComp.opacity > 0)
                    displayComp.opacity -= 1 / animate.duration / 16;
                else
                    Ntry.entityManager.removeComponent(
                        entity.id, Ntry.STATIC.ANIMATE);
                break;
            case Ntry.STATIC.POP_OUT:
                var scale = Math.sin(((animate.currentFrame + 6) / 16) * Math.PI) * 1.2;
                displayComp.scaleX = scale;
                displayComp.scaleY = scale;
                animate.currentFrame++;
                if (animate.currentFrame >= 10) {
                    Ntry.entityManager.removeComponent(
                        entity.id, Ntry.STATIC.ANIMATE);
                    Ntry.entityManager.removeComponent(
                        entity.id, displayComp.type);
                }
                break;
            case Ntry.STATIC.VIBRATE:
                var position = Ntry.entityManager.getComponent(
                    entity.id, Ntry.STATIC.POSITION);
                position.x = animate.animateValue +
                    10 * Math.sin((animate.currentFrame / 4) * Math.PI);
                animate.currentFrame++;
                if (animate.currentFrame >= 24) {
                    Ntry.entityManager.removeComponent(
                        entity.id, Ntry.STATIC.ANIMATE);
                }
                break;
        }
    }



})(Ntry.Animator.prototype);
